module.exports = __webpack_public_path__ + "static/media/hammerhub.0bede82a.svg";